import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgParty = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.268 3.04a.75.75 0 0 0-.466.954 5.35 5.35 0 0 1-.163 3.898.75.75 0 0 0 1.374.602 6.85 6.85 0 0 0 .207-4.987.75.75 0 0 0-.953-.466m3.25 3.677a.75.75 0 1 1 1.485-.217c.128.88-.087 1.77-.598 2.502a.75.75 0 0 1-1.23-.859c.296-.424.416-.93.343-1.426M7.806 9.15c.176-.043.362-.043.538 0 .172.041.328.122.453.232l5.959 5.662a.9.9 0 0 1 .24.398.86.86 0 0 1 .01.45.9.9 0 0 1-.225.408 1.04 1.04 0 0 1-.427.27l-.012.004-9.516 3.371c-.177.059-.37.07-.555.032a1 1 0 0 1-.484-.245.9.9 0 0 1-.26-.424.8.8 0 0 1 .011-.46l3.528-9.028.011-.03a.95.95 0 0 1 .268-.4c.127-.113.285-.197.461-.24M5.32 21.362l9.518-3.37a2.54 2.54 0 0 0 1.034-.662c.286-.303.49-.674.59-1.079s.091-.828-.026-1.228a2.4 2.4 0 0 0-.635-1.054l-.007-.007L9.82 8.286l-.018-.016a2.6 2.6 0 0 0-1.105-.577c-.41-.1-.838-.1-1.248 0s-.79.298-1.104.579a2.45 2.45 0 0 0-.683 1.016l-3.53 9.035-.012.035c-.145.432-.16.895-.043 1.335.116.44.359.836.694 1.144s.75.518 1.195.61.922.06 1.353-.085m11.797-8.48a2.32 2.32 0 0 1 1.572.214.75.75 0 0 0 .702-1.326 3.82 3.82 0 0 0-2.59-.354.75.75 0 0 0 .316 1.466M20.5 7.218q0 .022.009.041.008.018.015.024l.013.008q.001 0 .013-.008a.1.1 0 0 0 .015-.024.1.1 0 0 0 0-.082.1.1 0 0 0-.015-.024l-.013-.008q-.001 0-.013.008a.1.1 0 0 0-.015.024.1.1 0 0 0-.01.04m.037-1.427c.771 0 1.463.603 1.463 1.427s-.692 1.427-1.463 1.427-1.463-.603-1.463-1.427.692-1.427 1.463-1.427"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgParty;
